export const LOADER_STATUS = "boilderplate/GSTR1NEWVIEW/LOADER_STATUS";
export const VIEW_TABLE_DATA = "boilerplate/GSTR1NEWVIEW/VIEW_TABLE_DATA";
export const DOC_LEVEL_DATA = "boilerplate/GSTR1NEWVIEW/DOC_LEVEL_DATA";
export const DOC_LEVEL_DATA_TABLE15 = "boilerplate/GSTR1NEWVIEW/DOC_LEVEL_DATA_TABLE15";
export const activeTabValues = {
  1: "stg_input_rif_data",
  2: "stg_input_b2cs_agg",
  3: "stg_input_ata_data",
  4: "stg_input_doc_data",
  5: "stg_input_hsn_data",
  6: "stg_input_nill",
  7: "stg_supplier_ecom_agg",
  8: "stg_ecom_invoice",
  9: "stg_ecom_agg",
};
